import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=2bc831eb&scoped=true&"
import script from "./Network.vue?vue&type=script&lang=js&"
export * from "./Network.vue?vue&type=script&lang=js&"
import style0 from "./Network.vue?vue&type=style&index=0&id=2bc831eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc831eb",
  null
  
)

export default component.exports